import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { BackgroundImage, BodyText, Icon } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { mobileIs } from "../../utils/siteUtils";
import { englishMonthTimer } from '../../utils/date-utils';
import "./style.scss";
import Swiper from 'swiper';
import gsap from 'gsap';

const TriangleGroup = props => {
	const { lang, rendering, fields, page } = props;
  const { pc_image, m_image, list } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const swiperEl = useRef(null)
  const swiper = useRef(null)
  const rootNode = useRef()
  const paginationEl = useRef()
  const imageEl = useRef()

  const buildSwiper = () => {
    swiper.current = new Swiper(swiperEl.current, {
      watchSlidesProgress: true,
      slidesPerView: 1,
      observer: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-prev",
        prevEl: ".swiper-button-next",
      }
    })
  }

  useEffect(() => {
    let timer = setTimeout(v => {
      if(isMobile) {
        buildSwiper()
      }
      clearTimeout(timer)
    }, 100)

    setTimeout(v => {
      let ScrollMagic, controller, scene, tl
      ScrollMagic = loadScrollMagic()
      controller = new ScrollMagic.Controller()
      tl = gsap.timeline()

      for (let i = 0; i < list.length; i++) {
        tl.add(gsap.to(imageEl.current, {
          y: 0,
        }), 1)
        .add(gsap.to(`#item__image_content${list[i].id}`, {
          y: 0,
        }), 2)
        .add(gsap.to(`#item__title${list[i].id}`, {
          y: 0,
          opacity: 1
        }), 2)
        .add(gsap.to(`#item__desc${list[i].id}`, {
          y: 0,
          opacity: 1
        }), 2)
        .add(gsap.to(paginationEl.current, {
          y: 0,
          opacity: 1
        }), 2)
        
      }
      
      scene = new ScrollMagic.Scene({
        triggerElement: rootNode.current,
        triggerHook: 0,
        offset: isMobile ? - window.innerHeight / 1 : - window.innerHeight / 1.2,
        duration: window.innerHeight * 0.6
      })
      .setTween(tl)
      .addTo(controller)

      return () => {
        scene.destroy(true);
        scene = null;
        controller.destroy(true);
        controller = null;
      };
    }, 200)
  }, [])

  const rootClasses = classNames("c-triangle-group", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
      <div className="c-triangle-group__top_image" ref={imageEl}>
        {!isMobile && <BackgroundImage {...pc_image} className="image" />}
        {isMobile && <BackgroundImage {...m_image} className="image" />}
      </div>

      <div className="c-triangle-group__swiper" ref={swiperEl}>
        <div className="swiper-wrapper">
          {list && list.map((item, index) => (
            <div className="swiper-slide" key={index}>
              <div className="image-content" id={`item__image_content${item.id}`}>
                <div className="image" style={{ backgroundImage: `url(${item?.fields?.m_image?.value?.src})` }} id={`item__image${item.id}`} />
              </div> 
              {!isMobile && <RichText tag="div" className="title" field={item?.fields?.pc_title} id={`item__title${item.id}`} />}
              {isMobile && <RichText tag="div" className="title" field={item?.fields?.m_title} id={`item__title${item.id}`} />}
              {!isMobile && <RichText tag="div" className="desc" field={item?.fields?.pc_desc} id={`item__desc${item.id}`} />}
              {isMobile && <RichText tag="div" className="desc" field={item?.fields?.m_desc} id={`item__desc${item.id}`} />}
            </div>
          ))}
        </div>
        <div className="pagination-content" ref={paginationEl}>
          <div className="swiper-button-next">
            <Icon name="ArrowBack" className="c-triangle-group__left" />
          </div>
          <div className="swiper-pagination"></div>
          <div className="swiper-button-prev">
            <Icon name="ArrowForward" className="c-triangle-group__right" />
          </div>
        </div>
      </div>

      <div className="c-triangle-group__list_content">
        {list && list.map((item, index) => (
          <div className="c-triangle-group__list_content__item" key={index}>
            <div className="image-content" id={`item__image_content${item.id}`}>
              <BackgroundImage {...(item.fields.pc_image)} className="image" id={`item__image${item.id}`} />
            </div>
            {!isMobile && <RichText tag="div" className="title" field={item?.fields?.pc_title} id={`item__title${item.id}`} />}
            {isMobile && <RichText tag="div" className="title" field={item?.fields?.m_title} id={`item__title${item.id}`} />}
            {!isMobile && <RichText tag="div" className="desc" field={item?.fields?.pc_desc} id={`item__desc${item.id}`} />}
            {isMobile && <RichText tag="div" className="desc" field={item?.fields?.m_desc} id={`item__desc${item.id}`} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default 	TriangleGroup;